import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getInsuranceSold } from "reducers/reports";
import Loader from "components/Loader";
import BarGraph from "./BarGraph";
import Filters from "./Filters";
import { Paper, Box, Typography } from "@mui/material";
import { horizontalScrollBarStyle } from "utils";

function InsuranceSoldReport({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedCompany,
  handleCampanyChange,
  selectedBrokers,
  handleBrokerChange,
  handleFilter,
  resetFilterBtn
}) {
  const { loading, data, filters } = useSelector(state => state.reports);
  const { theme } = useSelector(state => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInsuranceSold());
  }, [dispatch, filters]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Filters
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedCompany={selectedCompany}
            handleCampanyChange={handleCampanyChange}
            selectedBrokers={selectedBrokers}
            handleBrokerChange={handleBrokerChange}
            handleFilter={handleFilter}
            resetFilterBtn={resetFilterBtn}
            reportData={data.insuranceSold.providers}
          />
          {data.insuranceSold.providers.length > 0 ? (
            <>
              <Typography
                color="text.primary"
                component="h4"
                variant="h4"
                marginTop="24px"
              >
                Providers
              </Typography>
              <Paper
                sx={theme => ({ bgcolor: theme.palette.background.default })}
                elevation={0}
              >
                <Box
                  height={data?.insuranceSold?.providers.length * 30 + 100}
                  style={{ overflowY: "hidden", overflowX: "scroll" }}
                  sx={theme => horizontalScrollBarStyle(theme)}
                >
                  <BarGraph
                    theme={theme}
                    data={data?.insuranceSold?.providers}
                    user={true}
                    indexBy={"name"}
                    keys={["count"]}
                  />
                </Box>
              </Paper>
            </>
          ) : (
            <Typography variant="h5" color="text.primary" component="h5">
              There is no report yet
            </Typography>
          )}
        </>
      )}
    </>
  );
}

export default InsuranceSoldReport;
